module.exports = {
  "country": "IE",
  "artist": "Jedward",
  "song": "Lipstick",
  "year": "2011",
  "place": "8",
  "spotify": "4gDQktCvIfPqo18AdHmkR4"
};